import { Editor as BaseEditor } from "./src";
class Editor extends BaseEditor {
	constructor(options) {
		super(options);

		this.bindings = options.bindings || {};
		this.orderedBindings = Object.values(this.bindings);
		this.controller = null;
		this.hotkeys = [];
		this.isActive = false;
	}

	onSelectionChange(event) {
		super.onSelectionChange(event);

		if (this.controller) {
			this.controller.abort();
		}

		// NOTE: On removing the selection event isn't called.
		const selection = this.getSelection();

		if (selection == null || !selection.isCollapsed()) {
			return false;
		}

		const result = this.search(/(^|\s+)@/, {
			selection,
		});

		const { mention } = this.context;

		if (result == null || result.length === 0) {
			mention.update({
				visible: false,
				result: [],
			});

			return false;
		}

		const [current] = result;

		if (current == null) {
			mention.update({
				visible: false,
				result: [],
			});

			return false;
		}

		this.controller = new AbortController();

		const { match } = current;

		// TODO: Do not query text if the lastSearchedText is the same.
		// TODO: Include it in the mention context.
		const range = document.createRange();
		range.setStart(
			current.first().node,
			current.first().offset + match[1].length
		);
		range.setEnd(
			current.last().node,
			current.last().offset + current.last().length
		);

		const currentPosition = range.getClientRects();

		if (this.isActive) {
			// TODO: Performance query in state, if the data is all the same - do not update.
			mention.update({
				visible: true,
				selectedIndex: 0,
				match: "",
				position: currentPosition,
				onClose: (isIos) => {
					this.isActive = false;
					const first = current.first();
					const last = current.last();

					if (first == null || last == null) {
						return;
					}

					const range = document.createRange();

					range.setStart(first.node, first.offset + match[1].length);
					range.setEnd(last.node, last.offset + last.length);

					if (selection) {
						selection.setRange(range);
					}
					if (!isIos) {
						range.collapse(false);
					} else {
						this.replaceWithText("@");
					}
				},
				onSelected: (data) => {
					this.isActive = false;
					const first = current.first();
					const last = current.last();

					if (first == null || last == null) {
						return;
					}

					const range = document.createRange();

					range.setStart(first.node, first.offset + match[1].length);
					range.setEnd(last.node, last.offset + last.length);

					if (selection) {
						selection.setRange(range);
					}

					this.replaceWithEntity({
						type: "mention",
						data,
					});
				},
				result: [],
			});
		}
	}

	onKeyDown(event) {
		for (const handler of this.hotkeys) {
			if (handler(event)) {
				return true;
			}
		}

		if (super.onKeyDown(event)) {
			return true;
		}

		for (const handler of this.orderedBindings) {
			if (handler(event)) {
				return true;
			}
		}

		return false;
	}

	onCompositionEnd(event) {
		if (
			event.data.length >= 0 &&
			event.data.lastIndexOf("\n") > -1 &&
			event.data.lastIndexOf("\n") === event.data.length - 1 &&
			event.target
		) {
			event.key = "Enter";

			for (const handler of this.orderedBindings) {
				if (handler(event)) {
					return true;
				}
			}
		}

		return super.onCompositionEnd(event);
	}

	onCopy(event) {
		event.preventDefault();

		const selection = this.getSelection();

		if (!selection) {
			return false;
		}

		event.clipboardData.setData("text/plain", selection.getText());

		return true;
	}

	onCut(event) {
		event.preventDefault();

		if (!this.onCopy(event)) {
			return false;
		}

		return this.selection.replace(document.createTextNode("\u200B"));
	}

	onPaste(event) {
		event.preventDefault();

		const text = event.clipboardData.getData("Text");

		const [first, ...rest] = text
			.trim()
			.split(/\n\n|\r\n|\r|\n/)
			.reduce((result, text) => {
				const length = text.trim().length;

				if (length) {
					result.push(text);
					return result;
				}

				const last = result[result.length - 1];

				if (!length && last && last.trim().length) {
					result.push(text);
					return result;
				}

				return result;
			}, [])
			.map((text) => document.createTextNode(text));

		if (!this.selection.replace(first)) {
			return false;
		}

		const selection = this.getSelection();

		if (selection == null || !selection.isCollapsed()) {
			return false;
		}

		let { container } = selection.single();
		let last = null;

		for (const node of rest) {
			const line = this.content.dom.create({
				element: "p",
				children: node.length ? node : { element: "br" },
			});

			container.parentNode.insertBefore(line, container.nextSibling);
			container = line;

			last = line.lastChild;
		}

		if (last) {
			this.selection.setCursor(last);
		}
	}
}

export default Editor;
